import React, {
  useState,
  ChangeEvent,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  scheduleInspection,
  getSalutations,
  checkPremiseCodeExistance,
  checkLicenceExistance,
  PremiseCodeDetails,
} from "../../api/apimethods";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../scripts/countryMobileCodes";
import { IInspectApplicationRequest } from "../../typings/interfaces/Requests/InspectApplicationRequest";
import { Holiday } from "../../typings/models/Holiday";
import fetchHolidaysMaster from "../../scripts/holidaysMaster";
import { IcountryOptions } from "../../typings/models/CountryOption";
import fetchCountryOptions from "../../scripts/countryOptions";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes } from 'date-fns';
import { AppContext, defaultAppContextData } from "../../services/appData";
import { useAuthService, useContextService } from "../../services";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
import { useConfig } from "../../context/ConfigProvider";
import Loader from "../../components/molecules/Loader";
interface MasterDataRadioButtonsProps {
  salutationOptions: ICodeMasterModel[];
}

const InspectionProfile: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;
  const { message } = notify();
  const inputHolidayRef = useRef(true);
  const inputCountryRef = useRef(true);
  const inputUserRef = useRef(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isalutation, setiSalutation] = useState("0");
  const [iapplicantName, setiApplicantName] = useState("");
  const [iUEN, setiUEN] = useState("");
  const [icompanyName, setiCompanyName] = useState("");
  const [ilicencenumber, setiLicenceNumber] = useState("");
  const [ipremiseCode, setiPremiseCode] = useState("");
  const [iorganizationAddress, setiOrganizationAddress] = useState("");
  const [iorganizationAddress2, setiOrganizationAddress2] = useState("0");
  const [iorganizationAddress3, setiOrganizationAddress3] = useState("");
  const [iorganizationAddress4, setiOrganizationAddress4] = useState("");
  const [iorganizationAddress5, setiOrganizationAddress5] = useState("");
  const [iorganizationAddress6, setiOrganizationAddress6] = useState("");
  const [iorganizationAddress7, setiOrganizationAddress7] = useState("");
  const [iorganizationAddress8, setiOrganizationAddress8] = useState("");
  const [iorganizationAddress9, setiOrganizationAddress9] = useState("");
  const [iorganizationAddress10, setiOrganizationAddress10] = useState("");
  const [imobileNo, setiMobileNo] = useState("");
  const [imobilecode, setiMobileCode] = useState("+65");
  const [iemail, setiEmail] = useState("");

  const [aorganizationAddress, setaOrganizationAddress] = useState("");
  const [aorganizationAddress2, setaOrganizationAddress2] = useState("0");
  const [aorganizationAddress3, setaOrganizationAddress3] = useState("");
  const [aorganizationAddress4, setaOrganizationAddress4] = useState("");
  const [aorganizationAddress5, setaOrganizationAddress5] = useState("");
  const [aorganizationAddress6, setaOrganizationAddress6] = useState("");
  const [aorganizationAddress7, setaOrganizationAddress7] = useState("");
  const [aorganizationAddress8, setaOrganizationAddress8] = useState("");
  const [aorganizationAddress9, setaOrganizationAddress9] = useState("");
  const [aorganizationAddress10, setaOrganizationAddress10] = useState("");

  const [ainspectionDateTime, setainspectionDateTime] = useState<Date | null>(
    null
  );
  const [ainspectionTime, setaInspectionTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [aRemarks, setaRemarks] = useState("");
  const [aModeofContact, setaModeofContact] = useState<number>(0);
  const [amobileNo, setaMobileNo] = useState("");
  const [amobilecode, setaMobileCode] = useState("+65");

  const [validEmail, setValidEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isalutationSelected, setiSalutationSelected] = useState(false);
  const [modeofContactSelected, setaModeofContactSelected] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1); // Set it to tomorrow
  const minDate = currentDate;

  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [afloorNoShowError, setafloorNoShowError] = useState(true);
  const [aunitNoShowError, setaunitNoShowError] = useState(true);
  const [ablockNoShowError, setablockNoShowError] = useState(true);
  const [apostalCodeShowError, setapostalCodeShowError] = useState(true);
  const [validaMobileNo, setValidaMobileNo] = useState(true);
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isTimeValid, setTimeValid] = useState(true);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [salutationOptions, setSalutationOptions] = useState<
    ICodeMasterModel[]
  >([]);
  const [licenceNumberNoShowError, setLicenceNumberNoShowError] =
    useState(true);
  const [premiseCodeNoShowError, setPremiseCodeNoShowError] = useState(true);
  let navigate = useNavigate();

  const isWeekend = (date: any) => {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday (0) or Saturday (6)
  };
  useEffect(() => {
    if (ipremiseCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(ipremiseCode);

          if (response.data) {
            setiOrganizationAddress3(response.data.blockHouseNumber || "");
            setiOrganizationAddress5(response.data.streetRoadName || "");
            setiOrganizationAddress6(response.data.floorNumber || "");
            setiOrganizationAddress7(response.data.unitNumber || "");
            setiOrganizationAddress8(response.data.buildingName || "");
            setiOrganizationAddress9(response.data.postalCode || "");
          }
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    }
  }, [ipremiseCode]);
  const isHoliday = (date: any) => {
    const dateString = date.toISOString().split("T")[0];
    return holidays.some(
      (holiday) =>
        // holiday.holidayDate.split("T")[0].includes(dateString)
        date.toDateString() === new Date(holiday.holidayDate).toDateString()
    );
  };

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;
      if (user !== undefined) {
        if (user.uen != undefined) setiUEN(user.uen);
        if (user.companyName != undefined) setiCompanyName(user.companyName);
        if (user.name != undefined) setiApplicantName(user.name);
        // if (user.idNo != undefined) setiNRIC(user.idNo);
        if (user.contactNo != undefined) {
          setiMobileCode(user.contactNo.substring(0, 3));
          setiMobileNo(user.contactNo.substring(3));
        }
        if (user.email != undefined) setiEmail(user.email);
        if (user.registeredAddresses != undefined) {
          setiOrganizationAddress("1");
          setiOrganizationAddress9(user?.registeredAddresses?.[0]?.postalCode);
          setiOrganizationAddress3(
            user?.registeredAddresses?.[0]?.blockHouseNo
          );
          setiOrganizationAddress5(user?.registeredAddresses?.[0]?.streetName);
          setiOrganizationAddress6(user?.registeredAddresses?.[0]?.floorLevel);
          setiOrganizationAddress7(user?.registeredAddresses?.[0]?.unit);
          setiOrganizationAddress8(
            user?.registeredAddresses?.[0]?.buildingName
          );
        }
      }
      const fetchSalutation = async () => {
        try {
          const response = await getSalutations();

          if (response.data) {
            const salutations = response.data.filter(
              (item) => item.name !== "Others" && item.name !== "Not Available"
            );
            setSalutationOptions(salutations);
          }
        } catch (error) {
          console.error("Error fetching salutations:", error);
          message(
            NotifyType.Error,
            "An error occurred while fetching salutations. Please try again."
          );
        }
      };

      fetchSalutation();
    }
  });

  // Handle holiday vaidation
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);

    if (isWeekend(selectedDateObj) || isHoliday(selectedDateObj)) {
      // If the selected date is a weekend or a holiday, prevent updating the state
      event.preventDefault();
      setisValidDate(false);
      setainspectionDateTime(null);
    } else {
      setainspectionDateTime(selectedDateObj);
      setisValidDate(true);
    }
  };

  //time validation
  const isValidTime = (time: any) => {
    const selectedTime = new Date(`2000-01-01T${time}`);
    const minTime = new Date(`2000-01-01T09:00`);
    const maxTime = new Date(`2000-01-01T17:00`);

    return selectedTime >= minTime && selectedTime <= maxTime;
  };

  const convertTo24HourFormat = (time: any) => {
    const [hours, minutes] = time.split(":");
    let hoursInt = parseInt(hours, 10);
    if (hoursInt < 12 && time.includes("PM")) {
      hoursInt += 12;
    }
    return `${hoursInt.toString().padStart(2, "0")}:${minutes}`;
  };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setiOrganizationAddress3(value);
      setblockNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress3(value);
        setblockNoShowError(true);
      } else {
        setblockNoShowError(false);
      }
    }
  };
  const ablockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setaOrganizationAddress3(value);
      setablockNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress3(value);
        setablockNoShowError(true);
      } else {
        setablockNoShowError(false);
      }
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;
    setiOrganizationAddress9(value);
    if (pattern.test(value)) {
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const apostalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setaOrganizationAddress9(value);
      setapostalCodeShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress9(value);
        setapostalCodeShowError(true);
      } else {
        setapostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setiOrganizationAddress7(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress7(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };
  const aunitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setaOrganizationAddress7(value);
      setaunitNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress7(value);
        setaunitNoShowError(true);
      } else {
        setaunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setiOrganizationAddress6(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress6(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const afloorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setaOrganizationAddress6(value);
      setafloorNoShowError(true);
    } else {
      if (value === "") {
        setaOrganizationAddress6(value);
        setafloorNoShowError(true);
      } else {
        setafloorNoShowError(false);
      }
    }
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setiMobileNo(value);
      if (value.length < 8) {
        setValidMobileNo(false);
      } else {
        setValidMobileNo(true);
      }
    } else {
      if (value === "") {
        setiMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setaMobileNo(value);
      if (value.length < 8) {
        setValidaMobileNo(false);
      } else {
        setValidaMobileNo(true);
      }
    } else {
      if (value === "") {
        setaMobileNo(value);
        setValidaMobileNo(true);
      } else {
        setValidaMobileNo(false);
      }
    }
  };

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setCountries(countries);
        setIsLoading(false);
        const defaultCountry = countries.find(
          (option) => option.label === "Singapore"
        )?.value;
        if (defaultCountry !== undefined) {
          setiOrganizationAddress10(defaultCountry);
          setaOrganizationAddress10(defaultCountry);
        }
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputHolidayRef.current) {
      inputHolidayRef.current = false;
      const fetchHolidaysData = async () => {
        const holidaysData = await fetchHolidaysMaster();
        setHolidays(holidaysData);
      };

      fetchHolidaysData();
    }
  }, []);

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var index = event.target.selectedIndex;
    setiOrganizationAddress10(event.target.options[index].text);
  };

  const ahandleCountryChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setaOrganizationAddress10(event.target.value);
  };

  const handleLicenceNumberBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    try {
      if (event.target.value?.length > 0) {
        const response = await checkLicenceExistance(event.target.value);
        if (!response.data) {
          setLicenceNumberNoShowError(false);
        } else {
          setLicenceNumberNoShowError(true);
        }
      } else {
        setLicenceNumberNoShowError(true);
      }
    } catch (error) {
      console.error("Error checking licence existence:", error);
      setLicenceNumberNoShowError(false);

      message(
        NotifyType.Error,
        "An error occurred while checking licence existence. Please try again."
      );
    }
  };

  const handlePremiseCodeBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    var response = await checkPremiseCodeExistance(event.target.value);
    if (!response.data) {
      setPremiseCodeNoShowError(false);
    } else {
      setPremiseCodeNoShowError(true);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let saltuation = isSalutationSelected();
      let modeofContact = isModeofContactSelected();
      setiSalutationSelected(saltuation);
      setaModeofContactSelected(modeofContact);

      // if (!reCaptchaResponse) {
      //   // reCAPTCHA validation failed
      //   setIsCaptchaValid(false);
      //   return;
      // }
      if (
        isValidDate &&
        checkboxChecked &&
        saltuation &&
        validEmail &&
        licenceNumberNoShowError
      ) {
        var response = null;
        setSubmiting(true);
        response = await scheduleInspection(inspectionRequestData);
        if (response.data) {
          setSubmiting(false);
          let inspectionNumber = response.data;
          let path = `/app-inspection-complete`;
          let date = fixTimezoneOffset(ainspectionDateTime)
            ?.toISOString()
            .split("T")[0];
          let time = ainspectionTime?.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          });
          let contactMethod = aModeofContact === 2 ? "Email" : "SMS";
          navigate(path, {
            state: { inspectionNumber, date, time, contactMethod },
          });
        } else {
          // API call failed
          setSubmiting(false);
          const errorMessage = "An error occurred. Please try again.";
          setErrorMessage(errorMessage); // Set the error message in state
        }
      }
    } catch (error) {
      setSubmiting(false);
      console.error(error);
    }
  }

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const inspectionRequestData: IInspectApplicationRequest = {
    personalInformation: {
      salutation: isalutation,
      name: iapplicantName,
      uen: iUEN,
      companyName: icompanyName,
      licenceNumber: ilicencenumber,
      premiseCode: ipremiseCode,
      AddressType: iorganizationAddress,
      mobileNo: imobileNo,
      email: iemail,
      typeofPremises: iorganizationAddress2,
      blockHouseNumber: iorganizationAddress3,
      houseNumber: iorganizationAddress4,
      streetName: iorganizationAddress5,
      floorNumber: iorganizationAddress6,
      unitNumber: iorganizationAddress7,
      buildingName: iorganizationAddress8,
      postalCode: iorganizationAddress9,
      country: iorganizationAddress10,
      mobileNoCode: imobilecode,
    },
    applicationInformation: {
      insAppTypeofPremises: aorganizationAddress2,
      insAppBlockHouseNumber: aorganizationAddress3,
      insAppHouseNumber: aorganizationAddress4,
      insAppStreetName: aorganizationAddress5,
      insAppFloorNumber: aorganizationAddress6,
      insAppUnitNumber: aorganizationAddress7,
      insAppBuildingName: aorganizationAddress8,
      insAppPostalCode: aorganizationAddress9,
      insAppCountry: aorganizationAddress10,
      insAppOrganizationAddress: aorganizationAddress,
      insAppHarvestDate: fixTimezoneOffset(ainspectionDateTime),
      insAppHarvestTime: fixTimezoneOffset(ainspectionTime) ?? null,
      insAppRemarks: aRemarks,
      insAppMobileNoCode: amobilecode,
      insAppMobileNo: amobileNo,
      insAppModeofContact: aModeofContact,
      insContactMobile: amobileNo,
      insContactMobileCode: amobilecode,
      supportingDocuments: null,
    },
    userInformation: {
      name: user?.name,
      idType: user?.idType,
      idNo: user?.idNo,
      email: user?.email,
      contactNo: user?.contactNo,
      companyName: user?.companyName,
      uen: user?.uen,
      registeredAddress: user?.registeredAddresses?.[0],
    },
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setiEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const isSalutationSelected = () => {
    return isalutation !== null && isalutation !== "0";
  };
  const isModeofContactSelected = () => {
    return aModeofContact !== null && aModeofContact !== 0;
  };

  return (
    <>
      <h2>Declaration</h2>
      <div className="inst-cnt mb-2">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={checkboxChecked}
            onChange={handleCheckboxChange}
            id="flexCheckDefault"
            required
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            I certify that the information given is true and complete to the
            best of my knowledge.
          </label>
          {submitted && !checkboxChecked && (
            <p className="error-message">
              Please confirm the declaration checkbox
            </p>
          )}
        </div>
      </div>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <h2 className="pb-0">User Information</h2>
        <div className="inst-cnt mt-4 mb-2">
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">{user.name}</label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  NRIC :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.idNo}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Mobile Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.contactNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Email :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.email}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <label htmlFor="name" className="form-label mb-2 fw-bold">
              Address
            </label>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Block/House Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.blockHouseNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Floor Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.floorLevel}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Street Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.streetName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Unit Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.unit}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Building Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.buildingName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Postal Code :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user?.registeredAddresses?.[0]?.postalCode}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          className="passport-details hidden csp-display-block"
          id="passport"
        >
          <h2 className="pb-0">Personal Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isSalutationSelected() ? "required" : ""
                }`}
              >
                1. Salutation <span className="star">*</span>{" "}
              </label>
              <div>
                {salutationOptions.map((option) => (
                  <div className="form-check" key={option.id}>
                    <input
                      className="form-check-input"
                      type="radio"
                      value={option.id}
                      checked={isalutation === option.id}
                      onChange={(event) => setiSalutation(event.target.value)}
                    />
                    <label key={option.id} className="form-check-label">
                      {option.name}
                    </label>
                  </div>
                ))}
              </div>
              {submitted && !isSalutationSelected() && (
                <div className="invalid-feedback">
                  Please select a Salutation.
                </div>
              )}
            </div>
            <div className="mb-2">
              <label htmlFor="sapplicantName" className="form-label mb-2">
                2. Name of Applicant <span className="star">*</span>{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="sapplicantName"
                placeholder="Type Applicant Name as per NRIC / Passport"
                value={iapplicantName}
                maxLength={255}
                onChange={(event) => setiApplicantName(event.target.value)}
                required
              />
              <div className="invalid-feedback">
                Please provide a Applicant Name.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                3. UEN <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sUEN"
                placeholder=""
                maxLength={12}
                value={iUEN}
                onChange={(event) => setiUEN(event.target.value)}
                required
              />
              <div className="invalid-feedback">Please provide a UEN.</div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Company Name <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="scompanyName"
                placeholder=""
                maxLength={100}
                value={icompanyName}
                onChange={(event) => setiCompanyName(event.target.value)}
                required
              />
              <div className="invalid-feedback">
                Please provide Company Name.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                5. Farm Licence Number
              </label>
              <input
                type="text"
                className="form-control"
                id="slicencenumber"
                placeholder=""
                maxLength={100}
                value={ilicencenumber}
                onChange={(event) => setiLicenceNumber(event.target.value)}
                onBlur={handleLicenceNumberBlur}
              />
              <div className="invalid-feedback">
                Please provide Licence Number.
              </div>
              {!licenceNumberNoShowError && (
                <div className="error-message  mb-3">
                  Licence Number does not exists
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                6. Premise Code <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="spremiseCode"
                placeholder=""
                maxLength={100}
                value={ipremiseCode}
                onChange={(event) => setiPremiseCode(event.target.value)}
                onBlur={handlePremiseCodeBlur}
                required
              />
              <div className="invalid-feedback">
                Please provide premise code.
              </div>
              {!premiseCodeNoShowError && (
                <div className="error-message  mb-3">
                  Premise Code does not exists
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                7. Organisational Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress"
                      //placeholder="Address Type"
                      value={iorganizationAddress}
                      onChange={(e) => setiOrganizationAddress(e.target.value)}
                      required
                    >
                      <option value="">Address Type</option>
                      <option value="1">Local</option>
                      {/* <option value="2">Foreign</option> */}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please provide an Address Type.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress2"
                      value={iorganizationAddress2}
                      onChange={(e) => setiOrganizationAddress2(e.target.value)}
                    >
                      <option value="">Select Type of Premises</option>
                      <option value="1">Cold Room[CR]</option>
                      <option value="2">
                        Factory and Processing Plant[FPP]
                      </option>
                      <option value="3">Farm[FM]</option>
                      <option value="4">Food Factory[FF]</option>
                      <option value="5">Office[OF]</option>
                      <option value="6">Residential[RE]</option>
                      <option value="7">Retail Outlet[RO]</option>
                      <option value="8">Show Room[SR]</option>
                      <option value="9">Warehouse[WH]</option>
                      <option value="10">FeedMill[FM]</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress3"
                      placeholder="Block/House Number"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress3}
                      onChange={blockNoHandler}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Block/House Num.
                    </div>
                    {!blockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress6"
                      placeholder="Floor Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress6}
                      onChange={floorNoHandler}
                      maxLength={3}
                    />
                    {!floorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress5"
                      placeholder="Street Name"
                      maxLength={64}
                      value={iorganizationAddress5}
                      onChange={(event) =>
                        setiOrganizationAddress5(event.target.value)
                      }
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Street Name.
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress7"
                      placeholder="Unit Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress7}
                      onChange={unitNoHandler}
                      maxLength={4}
                    />
                    {!unitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress9"
                      placeholder="Postal Code"
                      maxLength={8}
                      value={iorganizationAddress9}
                      onChange={postalCodeHandler}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Postal Code.
                    </div>
                    {!postalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress8"
                      placeholder="Building Name"
                      maxLength={64}
                      value={iorganizationAddress8}
                      onChange={(event) =>
                        setiOrganizationAddress8(event.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress10"
                      value={iorganizationAddress10}
                      onChange={handleCountryChange}
                      required
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                8. Mobile Number <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="smobilecode"
                    value={imobilecode}
                    onChange={(e) => setiMobileCode(e.target.value)}
                    required
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className="form-control"
                    id="smobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={imobileNo}
                    onChange={mobileNoHandler}
                    maxLength={12}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a mobile.
                  </div>
                  {!validMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                9. Email<span className="star">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                id="semail"
                value={iemail}
                maxLength={255}
                onChange={handleEmailChange}
                placeholder="Enter email"
                required
              />
              <div className="invalid-feedback">Please provide a email.</div>
              {!validEmail && (
                <p className="error-message">
                  Invalid email format. eg. abc@de.lk
                </p>
              )}
            </div>
          </div>
          <h2 className="pt-2 pb-0">Application Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                10. Inspection Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress"
                      //placeholder="Address Type"
                      value={aorganizationAddress}
                      onChange={(e) => setaOrganizationAddress(e.target.value)}
                      required
                    >
                      <option value="">Address Type</option>
                      <option value="1">Local</option>
                      {/* <option value="2">Foreign</option> */}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please provide an Address Type.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress2"
                      value={aorganizationAddress2}
                      onChange={(e) => setaOrganizationAddress2(e.target.value)}
                    >
                      <option value="">Select Type of Premises</option>
                      <option value="1">Cold Room[CR]</option>
                      <option value="2">
                        Factory and Processing Plant[FPP]
                      </option>
                      <option value="3">Farm[FM]</option>
                      <option value="4">Food Factory[FF]</option>
                      <option value="5">Office[OF]</option>
                      <option value="6">Residential[RE]</option>
                      <option value="7">Retail Outlet[RO]</option>
                      <option value="8">Show Room[SR]</option>
                      <option value="9">Warehouse[WH]</option>
                      <option value="10">FeedMill[FM]</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress3"
                      placeholder="Block/House Number"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress3}
                      onChange={ablockNoHandler}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Block/House Num.
                    </div>
                    {!ablockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-6">
                    <div className="mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="sorganizationAddress4"
                        placeholder="House Number"
                        maxLength={10}
                        value={sorganizationAddress4}
                        onChange={(event) =>
                          setsOrganizationAddress4(event.target.value)
                        }
                      />
                    </div>
                  </div> */}
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress6"
                      placeholder="Floor Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress6}
                      onChange={afloorNoHandler}
                      maxLength={3}
                    />
                    {!afloorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress5"
                      placeholder="Street Name"
                      maxLength={64}
                      value={aorganizationAddress5}
                      onChange={(event) =>
                        setaOrganizationAddress5(event.target.value)
                      }
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Street Name.
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress7"
                      placeholder="Unit Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={aorganizationAddress7}
                      onChange={aunitNoHandler}
                      maxLength={4}
                    />
                    {!aunitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress9"
                      placeholder="Postal Code"
                      maxLength={8}
                      pattern="[0-9]+"
                      value={aorganizationAddress9}
                      onChange={apostalCodeHandler}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Postal Code.
                    </div>
                    {!apostalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress8"
                      placeholder="Building Name"
                      maxLength={64}
                      value={aorganizationAddress8}
                      onChange={(event) =>
                        setaOrganizationAddress8(event.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress10"
                      value={aorganizationAddress10}
                      onChange={ahandleCountryChange}
                      // value={sorganizationAddress10}
                      // onChange={(e) =>
                      //   setsOrganizationAddress10(e.target.value)
                      // }
                      required
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                11. Date of Inspection{" "}
                <span className="bracket-text">
                  (Please exclude public holidays and weekends)
                </span>{" "}
                <span className="star">*</span>
              </label>
              {/* <input
                type="date"
                className="form-control"
                id="sHarvestDate"
                value={ainspectionDateTime}
                onChange={handleDateChange}
                min={minDate}
                required
              /> */}
              <DatePicker
                id="sHarvestDate"
                selected={ainspectionDateTime}
                onChange={(date: Date | null) => setainspectionDateTime(date)}
                className="form-control"
                wrapperClassName="w-100"
                minDate={minDate}
                showIcon
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                filterDate={(date) => !isWeekend(date) && !isHoliday(date)}
                required
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Date of Inspection.
                </div>
              )}

              {!isValidDate && (
                <p className="error-message">
                  Inspection date to be from Monday to Friday, excluding public
                  holidays.
                </p>
              )}
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                12. Time of Inspection{" "}
                <span className="bracket-text">
                  (Please select a time between 09:00 to 17:00)
                </span>{" "}
                <span className="star">*</span>
              </label>
              {/* <input
                type="time"
                className={`form-control ${!isTimeValid ? "is-invalid" : ""}`}
                id="sInspectionTime"
                value={convertTo24HourFormat(ainspectionTime)}
                onChange={(event) => {
                  setaInspectionTime(event.target.value);
                  setTimeValid(isValidTime(event.target.value));
                }}
                min="09:00"
                max="17:00"
                required
                pattern="^(0[9]|1[0-6]):[0-5][0-9]$"
              /> */}
              <DatePicker
                id="sInspectionTime"
                selected={ainspectionTime}
                onChange={(date: Date | null) => {
                  setaInspectionTime(date);
                }}
                className="form-control"
                wrapperClassName="w-100"
                showTimeSelect
                showTimeSelectOnly
                minTime={setHours(setMinutes(new Date(), 0), 9)}
                maxTime={setHours(setMinutes(new Date(), 0), 17)}
                placeholderText="HH:mm am"
                dateFormat="hh:mm aa"
                timeIntervals={30}
                required
              />
              {!isTimeValid && (
                <div className="invalid-feedback mb-3">
                  Inspection time to be between 09:00 to 17:00.
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                13. Remarks
              </label>
              <input
                type="text"
                className="form-control"
                id="sRemarks"
                placeholder=""
                maxLength={500}
                value={aRemarks}
                onChange={(event) => setaRemarks(event.target.value)}
              />
            </div>
            {/* <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isModeofContactSelected() ? "required" : ""
                }`}
              >
                14. Mode of contact for Inspection Updates{" "}
                <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isModeofContactSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="amodeofContact"
                  value="Email"
                  id="flexRadioDefault66"
                  checked={aModeofContact === 2}
                  onChange={() => setaModeofContact(2)}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Email
                </label>
              </div>
              <div
                className={`form-check ${
                  !isModeofContactSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="amodeofContact"
                  value="SMS"
                  id="flexRadioDefault77"
                  checked={aModeofContact === 1}
                  onChange={() => setaModeofContact(1)}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault77"
                >
                  SMS
                </label>
              </div>
              {submitted && !isModeofContactSelected() && (
                <div className="invalid-feedback">
                  Please select a Mode of Contact.
                </div>
              )}
            </div> */}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                14. Inspection Contact Mobile <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="smobilecode"
                    value={amobilecode}
                    onChange={(e) => setaMobileCode(e.target.value)}
                    required
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className="form-control"
                    id="smobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={amobileNo}
                    onChange={amobileNoHandler}
                    maxLength={12}
                    required
                  />
                  <div className="invalid-feedback mb-3">
                    Please provide a mobile.
                  </div>
                  {!validaMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={site_Key}
              onChange={() => setIsCaptchaValid(true)}
              onExpired={() => setIsCaptchaValid(false)}
            />
            {submitted && !isCaptchaValid && (
              <div className="error-message">
                Please complete the reCAPTCHA verification.
              </div>
            )}
          </div>

          <button type="submit" className="btn btn-success d-block mt-4">
            Submit
          </button>
          {isSubmiting && <Loader />}

          {errorMessage && <p>{errorMessage}</p>}
        </div>
      </form>
    </>
  );
};

export default InspectionProfile;
